import React, { useState, useEffect } from 'react';
import TopicCard from './TopicCard';
import { Container, Row, Col, Badge, Button, Card, CardHeader, CardBody } from "shards-react";

// import PageTitle from "./../components/common/PageTitle";
import PageTitle from "../common/PageTitle"

const axios = require('axios').default;

export default function TopicsOverviewTable() {
  const [data, setData] = useState([]);


  function compareTopicId(a, b) {
    if (a.topic_number > b.topic_number) return -1;
    if (b.topic_number > a.topic_number) return 1;

    return 0;
  }

  useEffect(() => {
    axios.get('topicsData.json') // topicsData.json
      .then(response => {

        response.data.sort(compareTopicId);
       

        setData(response.data);
      })
  }, []);

  return (
    <Container className="bg-dark" style={{ maxWidth: '100%' }}>
      <Row noGutters className="page-header py-4">
          <PageTitle title="Real-Time Tracking of 2020 Election Disinformation - Topics Table" 
           subtitle={<h6>
            <a target="_blank" class="text-warning " href="http://project-echo.ucdavis.edu">&laquo; Back to Project ECHO Home Page </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/january"> | January </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/december"> | December </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/november"> | November </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/october"> | October </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/september"> | September </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/August"> | August </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/June-and-July"> | June and July </a>
            <a target="_blank" class="text-warning " href="http://34.209.246.203/topics-table"> | Got Bots?</a>
                      
          </h6> }
           className="text-sm-left text-warning"  />
          
        </Row>
      

      {data && data.slice(0, 0).map((topicData) =>
        <Row key={topicData.title}>
          <Col className="py-4"><TopicCard data={topicData} /></Col>
          <div>
      </div>
          
        </Row>
        
        
        

      )}

      <Row key="table" className="mx-2 my-4 bg-dark">
        <Col className="px-0">
          <Card className="overflow-hidden">
            <CardHeader className="p-3 bg-dark">
              <h6 className="m-0 text-white">All tracked topics</h6>
            </CardHeader>
            <CardBody className="bg-light p-0 pb-3">
              <table className="table mb-0">
                <thead className="bg-light">
                <tr>
                  <th scope="col">#</th>
                    <th scope="col" className="border-0">
                    Topic Title
                  </th>

                  <th scope="col" className="border-0">
                      High Botness Count <sup>1</sup>
                      
                  </th>
                  <th scope="col" className="border-0">
                    Fully Automated Accounts <sup>2</sup>
                  </th>
                  
                    <th scope="col" className="border-0">
                     Total Accounts Collected
                  </th>
                    
                    <th scope="col" className="border-0">
                      External URL
                  </th>
                  </tr>
                </thead>
                <tbody>
                  {data && data.map((topicData) =>
                    <tr key={"tr" + topicData.title} className="p-4">
                      
                      <th scope="row">{topicData.topic_number}</th>
                      <td>{topicData.title}</td>
                      <td><Badge theme="danger">{topicData.high_botness_cnt}</Badge>
                      </td>
                      <td><Badge theme="danger">{topicData.automated}</Badge>
                      </td>
                      <td><Badge theme="info">{topicData.total_count}</Badge>
                      </td>

                      <td><a target="blank" href={topicData.url}><Button outline theme="info" className="float-right">
                      Fact Analysis </Button></a></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <div> 1. Botometer Display Score > 4 out of 5. </div>
    <div> 2. Based on Botometer’s Complete Automation Probability (CAP) of 60% or higher. </div>

    </Container>



  )
}
